var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.28 492.373C495.317 495.13 492.726 497.381 489.721 498.939C486.717 500.497 483.385 501.318 480 501.333H32C28.6154 501.318 25.2832 500.497 22.2785 498.939C19.2738 497.381 16.683 495.13 14.72 492.373C98.9866 304.96 81.4933 343.893 106.667 288H405.333C432.427 348.267 412.373 303.787 497.28 492.373Z",
    fill: "#138CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 149.333V288C79.5733 348.267 99.6266 303.787 14.72 492.374C12.0447 488.807 10.62 484.458 10.6666 480V330.667L106.667 149.333Z",
    fill: "url(#paint0_linear_2611_1998)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 330.667V480C501.38 484.458 499.955 488.807 497.28 492.374C413.013 304.96 430.507 343.893 405.333 288V149.333L501.333 330.667Z",
    fill: "url(#paint1_linear_2611_1998)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M501.333 330.667V480C501.333 485.658 499.086 491.084 495.085 495.085C491.084 499.086 485.658 501.333 480 501.333H32C26.342 501.333 20.9158 499.086 16.915 495.085C12.9142 491.084 10.6666 485.658 10.6666 480V330.667H192.96C195.532 330.638 198.029 331.539 199.989 333.205C201.949 334.871 203.241 337.19 203.627 339.733C205.271 349.384 209.541 358.396 215.967 365.782C222.393 373.167 230.728 378.641 240.058 381.605C249.389 384.568 259.355 384.906 268.865 382.582C278.375 380.257 287.062 375.36 293.973 368.427C301.728 360.6 306.902 350.587 308.8 339.733C309.186 337.19 310.478 334.871 312.438 333.205C314.398 331.539 316.894 330.638 319.467 330.667H501.333Z",
    fill: "url(#paint2_linear_2611_1998)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 149.333H405.333V288H106.667V149.333Z",
    fill: "url(#paint3_linear_2611_1998)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352 106.667C352.024 88.3904 346.831 70.487 337.031 55.0606C327.231 39.6341 313.231 27.3257 296.676 19.5819C280.121 11.8382 261.7 8.98082 243.578 11.3457C225.455 13.7107 208.384 21.1996 194.371 32.9323C180.358 44.665 169.986 60.154 164.472 77.5788C158.959 95.0036 158.534 113.64 163.248 131.298C167.961 148.956 177.618 164.901 191.082 177.26C204.545 189.62 221.257 197.878 239.253 201.067L251.2 225.173C251.664 226.043 252.356 226.771 253.201 227.278C254.047 227.785 255.014 228.053 256 228.053C256.986 228.053 257.953 227.785 258.799 227.278C259.644 226.771 260.336 226.043 260.8 225.173L272.747 201.067C294.936 197.136 315.035 185.524 329.524 168.266C344.014 151.007 351.97 129.201 352 106.667Z",
    fill: "url(#paint4_linear_2611_1998)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.04 106.667L295.573 82.2402C297.582 80.2316 298.71 77.5074 298.71 74.6669C298.71 71.8263 297.582 69.1021 295.573 67.0935C293.565 65.0849 290.841 63.9565 288 63.9565C285.159 63.9565 282.435 65.0849 280.427 67.0935L256 91.6269L231.573 67.0935C230.579 66.099 229.398 65.3101 228.099 64.7718C226.799 64.2336 225.406 63.9565 224 63.9565C221.159 63.9565 218.435 65.0849 216.427 67.0935C214.418 69.1021 213.29 71.8263 213.29 74.6669C213.29 77.5074 214.418 80.2316 216.427 82.2402L240.96 106.667L216.427 131.094C215.432 132.088 214.643 133.269 214.105 134.568C213.567 135.868 213.29 137.26 213.29 138.667C213.29 141.507 214.418 144.232 216.427 146.24C218.435 148.249 221.159 149.377 224 149.377C225.406 149.377 226.799 149.1 228.099 148.562C229.398 148.024 230.579 147.235 231.573 146.24L256 121.707L280.427 146.24C282.435 148.249 285.159 149.377 288 149.377C290.841 149.377 293.565 148.249 295.573 146.24C297.582 144.232 298.71 141.507 298.71 138.667C298.71 135.826 297.582 133.102 295.573 131.094L271.04 106.667Z",
    fill: "#FFB369"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.333 405.333H53.3333C47.4423 405.333 42.6666 410.109 42.6666 416V458.667C42.6666 464.558 47.4423 469.333 53.3333 469.333H117.333C123.224 469.333 128 464.558 128 458.667V416C128 410.109 123.224 405.333 117.333 405.333Z",
    fill: "url(#paint5_linear_2611_1998)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96 448H74.6667C71.8377 448 69.1246 446.876 67.1242 444.876C65.1238 442.875 64 440.162 64 437.333C64 434.504 65.1238 431.791 67.1242 429.791C69.1246 427.79 71.8377 426.667 74.6667 426.667H96C98.829 426.667 101.542 427.79 103.542 429.791C105.543 431.791 106.667 434.504 106.667 437.333C106.667 440.162 105.543 442.875 103.542 444.876C101.542 446.876 98.829 448 96 448Z",
    fill: "#FFB369"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.333 469.333H160C157.171 469.333 154.458 468.21 152.458 466.209C150.457 464.209 149.333 461.496 149.333 458.667C149.333 455.838 150.457 453.125 152.458 451.124C154.458 449.124 157.171 448 160 448H181.333C184.162 448 186.875 449.124 188.876 451.124C190.876 453.125 192 455.838 192 458.667C192 461.496 190.876 464.209 188.876 466.209C186.875 468.21 184.162 469.333 181.333 469.333ZM202.667 426.667H160C157.171 426.667 154.458 425.543 152.458 423.543C150.457 421.542 149.333 418.829 149.333 416C149.333 413.171 150.457 410.458 152.458 408.458C154.458 406.457 157.171 405.333 160 405.333H202.667C205.496 405.333 208.209 406.457 210.209 408.458C212.21 410.458 213.333 413.171 213.333 416C213.333 418.829 212.21 421.542 210.209 423.543C208.209 425.543 205.496 426.667 202.667 426.667Z",
    fill: "#138CE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2611_1998",
    x1: 58.6666,
    y1: 492.374,
    x2: 58.6666,
    y2: 149.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EA3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71B9F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2611_1998",
    x1: 453.333,
    y1: 492.374,
    x2: 453.333,
    y2: 0.000175832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EA3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71B9F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2611_1998",
    x1: 256,
    y1: 501.333,
    x2: 256,
    y2: 330.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EA3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71B9F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2611_1998",
    x1: 256,
    y1: 288,
    x2: 256,
    y2: 0.000163885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EA3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71B9F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2611_1998",
    x1: 256,
    y1: 228.053,
    x2: 256,
    y2: 10.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2611_1998",
    x1: 42.6666,
    y1: 437.333,
    x2: 128,
    y2: 437.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F7FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a4cd89ca91a60187e5e2f2e131727062.svg";
export { ForwardRef as ReactComponent };